module.exports = __webpack_public_path__ + "img/image-11.29db8a26.png";